(() => {
  // Match complete emoji sequences, including skin tones, flags and joined glyphs.
  const emoji =
    /(?:[✓✔]\uFE0F?|\p{Regional_Indicator}{2}|[#*0-9]\uFE0F?\u20E3|(?:(?![©®™])\p{Extended_Pictographic})(?:\uFE0F|\p{Emoji_Modifier})*(?:\u200D\p{Extended_Pictographic}(?:\uFE0F|\p{Emoji_Modifier})*)*)/gu;
  const replaceIcons = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      if (node.parentElement.closest("svg, script, style, textarea, code, pre"))
        return;
      const matches = [...node.textContent.matchAll(emoji)];
      if (!matches.length) return;
      const fragment = document.createDocumentFragment();
      let offset = 0;
      matches.forEach((match) => {
        fragment.append(node.textContent.slice(offset, match.index));
        const icon = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg",
        );
        icon.setAttribute("class", "sec-CaseStudy_Icon");
        icon.setAttribute("viewBox", "0 0 24 24");
        icon.setAttribute("aria-hidden", "true");
        icon.setAttribute("fill", "none");
        icon.setAttribute("stroke", "currentColor");
        icon.setAttribute("stroke-width", "1.8");
        icon.setAttribute("stroke-linecap", "round");
        icon.setAttribute("stroke-linejoin", "round");
        const path = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "path",
        );
        path.setAttribute("d", "m5 12 4 4L19 6");
        icon.append(path);
        if (!node.parentElement.closest(".sec-CaseStudy_Goal"))
          fragment.append(icon);
        offset = match.index + match[0].length;
      });
      fragment.append(node.textContent.slice(offset));
      node.replaceWith(fragment);
    });
    // Normalise adjacent legacy markers into one icon per text item.
    root.querySelectorAll(".sec-CaseStudy_Icon").forEach((icon) => {
      let previous = icon.previousSibling;
      while (
        previous?.nodeType === Node.TEXT_NODE &&
        !previous.textContent.trim()
      )
        previous = previous.previousSibling;
      if (previous?.classList?.contains("sec-CaseStudy_Icon")) {
        icon.remove();
        return;
      }
      const link = icon.closest("a");
      const line = icon.closest("p, li");
      if (
        link ||
        (line?.querySelector("a[href]") &&
          /^(visit|view)\b/i.test(line.textContent.trim()))
      ) {
        icon.classList.add("sec-CaseStudy_Icon-arrow");
        icon.querySelector("path")?.setAttribute("d", "M5 19 19 5 M5 5h14v14");
      }
    });
  };
  document.querySelectorAll(".sec-CaseStudy_Outer").forEach(replaceIcons);
  if (!window.projectIconsListening) {
    document.addEventListener("shopify:section:load", (event) => {
      event.target
        .querySelectorAll(".sec-CaseStudy_Outer")
        .forEach(replaceIcons);
    });
    window.projectIconsListening = true;
  }
})();
